import { avatarDef } from "@/content/heroes";
import { getItem } from "@/content/items";
import { lt, t } from "@/i18n";
import { activeQuests } from "@/quests/QuestController";
import { hero, itemCount, xpToNext } from "@/state/store";

export function Hud() {
  const h = hero.value;
  const hpPct = Math.round((h.hp / h.hpMax) * 100);
  const xpPct = Math.round((h.xp / xpToNext(h.lvl)) * 100);
  // ready-to-turn-in quests first, then the rest; the HUD shows three, the backpack all
  const allQuests = activeQuests(h).sort(
    (a, b) => Number(b.progress >= b.def.objective.count) - Number(a.progress >= a.def.objective.count),
  );
  const quests = allQuests.slice(0, 3);
  const hiddenQuests = allQuests.length - quests.length;
  const gear = [h.equipment.weapon, h.equipment.armor, h.equipment.accessory].filter(
    (id): id is string => !!id,
  );
  const potions = itemCount(h, "potion") + itemCount(h, "big_potion");
  return (
    <div class="hud">
      <div class="hud-name">
        <img class="faceset small" src={avatarDef(h.avatar).faceset} alt="" />
        <span class="hud-name-text">
          <strong>{h.name}</strong>
        </span>
      </div>
      <div class="bar hp" title={`${h.hp}/${h.hpMax}`}>
        <div class="fill" style={{ width: `${hpPct}%` }} />
        <span>
          {h.hp}/{h.hpMax}
        </span>
      </div>
      <div class="bar xp">
        <div class="fill" style={{ width: `${xpPct}%` }} />
        <span>
          {t("hud.lv")} {h.lvl} · {t("hud.xp")} {h.xp}/{xpToNext(h.lvl)}
        </span>
      </div>
      <div class="hud-row">
        <span>💰 {h.gold}</span>
        <span>🧪 {potions}</span>
        {itemCount(h, "hint_scroll") > 0 && <span>📜 {itemCount(h, "hint_scroll")}</span>}
        {h.streak > 0 && <span>🔥 {h.streak}</span>}
      </div>
      <div class="hud-gear">
        {gear.map((id) => (
          <span key={id} title={lt(getItem(id).name)}>
            {getItem(id).icon}
          </span>
        ))}
      </div>
      {quests.length > 0 && (
        <div class="hud-quests">
          {quests.map(({ def, progress }) => {
            const ready = progress >= def.objective.count;
            return (
              <div key={def.id} class={`hud-quest ${ready ? "ready" : ""}`}>
                {ready ? "✅" : "📜"} {lt(def.title)} {progress}/{def.objective.count}
              </div>
            );
          })}
          {hiddenQuests > 0 && <div class="hud-quest more">{t("hud.moreQuests", { n: hiddenQuests })}</div>}
        </div>
      )}
    </div>
  );
}
